<template>
  <header class="intelligence-header px-4 py-3">
    <div class="intelligence-header__identity">
      <span class="intelligence-header__logo">
        <img src="/favicon-32x32.png" alt="" aria-hidden="true" />
      </span>
      <div class="intelligence-header__title-wrap">
        <h2 class="intelligence-header__title f16 fw500">ProApp Intelligence</h2>
      </div>
    </div>
    <div class="intelligence-header__actions">
      <BaseTooltip
        v-if="showSettings"
        :tooltip="settingsOpen ? 'Back to home' : 'Response settings'"
      >
        <button
          :class="{'intelligence-header__settings': !settingsOpen}"
          type="button"
          :aria-label="settingsOpen ? 'Back to chat home' : 'Open response settings'"
          @click="$emit('toggle-settings')"
        >
          <v-icon v-if="settingsOpen" size="22" color="primary">
            mdi-arrow-left
          </v-icon>
          <v-icon v-else size="21" color="#757575">mdi-cog-outline</v-icon>
        </button>
      </BaseTooltip>
      <BaseTooltip v-if="hasConversation" tooltip="Back to home">
        <button type="button" aria-label="Return to chat home" @click="$emit('reset')">
          <v-icon size="22" color="primary">mdi-arrow-left</v-icon>
        </button>
      </BaseTooltip>
      <BaseTooltip :tooltip="expanded ? 'Restore size' : 'Expand'">
        <button
          class="intelligence-header__expand"
          type="button"
          :aria-label="expanded ? 'Restore chat size' : 'Expand chat'"
          @click="$emit('toggle-expand')"
        >
          <v-icon size="21" color="primary">
            {{ expanded ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all' }}
          </v-icon>
        </button>
      </BaseTooltip>
      <BaseTooltip tooltip="Close">
        <button type="button" aria-label="Close ProApp Intelligence" @click="$emit('close')">
          <v-icon size="22" color="primary">mdi-close</v-icon>
        </button>
      </BaseTooltip>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ProAppIntelligenceHeader',
  props: {
    expanded: Boolean,
    hasConversation: Boolean,
    showSettings: Boolean,
    settingsOpen: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.intelligence-header {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--v-secondary-lighten3);
  background: white;

  &__identity,
  &__actions,
  &__title-wrap {
    display: flex;
    align-items: center;
  }

  &__identity {
    min-width: 0;
    gap: 10px;
  }

  &__logo {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--v-secondary-lighten5);

    img {
      width: 27px;
      height: 27px;
    }
  }

  &__title-wrap {
    min-width: 0;
    gap: 7px;
  }

  &__title {
    line-height: 1.2;
    color: var(--v-secondary-darken4);
    white-space: nowrap;
  }

  &__actions {
    gap: 2px;

    button {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: background-color 0.2s ease, opacity 0.2s ease;

      &:hover,
      &:focus-visible {
        background: var(--v-primary-lighten5);
      }
    }
  }

  &__settings {
    opacity: 0.1;

    &:hover,
    &:focus-visible {
      opacity: 0.8;
    }
  }
}

@media screen and (max-width: 999px) {
  .intelligence-header__expand {
    display: none !important;
  }
}

@media screen and (max-width: 380px) {
  .intelligence-header {
    padding-left: 12px !important;
    padding-right: 8px !important;

    &__title {
      font-size: 0.875rem !important;
    }

  }
}
</style>
